"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
Object.defineProperty(exports, "__esModule", { value: true });
;
window.ga_debug = { trace: false };
var GAHitType;
(function (GAHitType) {
    GAHitType["event"] = "ga_event";
    GAHitType["page"] = "vpv";
})(GAHitType = exports.GAHitType || (exports.GAHitType = {}));
var Analytics = /** @class */ (function () {
    function Analytics(props) {
        this.getPersonId = props.personId;
        this.getDataSource = props.dataSource;
        this.getContactId = props.contactId;
    }
    Analytics.prototype.track = function (hitType, fieldsObject) {
        var gtmWindow = window;
        if (!gtmWindow.dataLayer)
            return;
        var id = this.getPersonId();
        var personID = id && typeof id === 'number' ? id.toString() : '';
        var contactID = this.getContactId();
        var emailContactId = contactID && typeof contactID === 'string' ? contactID : '';
        gtmWindow.dataLayer.push(__assign({ hitType: hitType,
            personID: personID, emailContactId: emailContactId, dataSource: this.getDataSource() }, fieldsObject));
        return gtmWindow.dataLayer;
    };
    Analytics.prototype.trackEvent = function (category, action, label) {
        var gtmWindow = window;
        if (!gtmWindow.dataLayer)
            return;
        var id = this.getPersonId();
        var personID = id && typeof id === 'number' ? id.toString() : '';
        var contactID = this.getContactId();
        var emailContactId = contactID && typeof contactID === 'string' ? contactID : '';
        gtmWindow.dataLayer.push({
            event: GAHitType.event,
            eventCategory: category,
            eventAction: action,
            eventLabel: label,
            personID: personID,
            emailContactId: emailContactId,
            dataSource: this.getDataSource(),
        });
        return gtmWindow.dataLayer;
    };
    Analytics.prototype.trackPage = function (pagePath, pageTitle) {
        var gtmWindow = window;
        if (!gtmWindow.dataLayer)
            return;
        var id = this.getPersonId();
        var personID = id && typeof id === 'number' ? id.toString() : '';
        var contactID = this.getContactId();
        var emailContactId = contactID && typeof contactID === 'string' ? contactID : '';
        gtmWindow.dataLayer.push({
            event: GAHitType.page,
            pagePath: pagePath,
            pageTitle: pageTitle,
            personID: personID,
            emailContactId: emailContactId,
            dataSource: this.getDataSource(),
        });
        return gtmWindow.dataLayer;
    };
    return Analytics;
}());
exports.Analytics = Analytics;
//personID: userProfileInfo.userProfiles[userProfileInfo.selectedPartyId].personId.toString()
//dataSource: (window as any as IOSWindow).isNativeIOS ? 'app' : 'web',
// function getPageTitle(pagePath:string): string | undefined {
//   const pathMap:{[key:string]: string} = { //static paths
//     [ACCOUNTS_URL]: 'Accounts Home',
//     [TASKS_URL + '/open']: 'Tasks Cashflow Open',
//     [TASKS_URL + '/past']: 'Tasks Cashflow Past',
//     [DOCUMENTS_URL]: 'Documents',
//     [CALENDAR_URL]: 'Calendar',
//     [INSIGHTS_URL]: 'Insights',
//     [HELP_URL]: 'Help Contact',
//     [SETTINGS_URL]: 'Account Settings',
//   };
//
//   const regexMap:{[key:string]: string} = { //dynamic paths
//     [`\\${ACCOUNTS_URL}\\/[0-9]+\\/performance`]: 'Account Performance',
//     [`\\${ACCOUNTS_URL}\\/[0-9]+\\/holdings`]: 'Account Holdings',
//     [`\\${ACCOUNTS_URL}\\/[0-9]+\\/transactions`]: 'Account Transactions',
//     [`\\${ACCOUNTS_URL}\\/[0-9]+\\/documents`]: 'Account Documents',
//     [`\\${INSIGHTS_URL}\\/[0-9]+`]: 'Insights Article',
//   };
//
//   let title = pathMap[pagePath];
//   if (!title) {
//     for (let key in regexMap) {
//       if (RegExp(key).test(pagePath)) return regexMap[key];
//     }
//   }
//
//   return title;
// }
// export function getCategoryFromProductType(category:GACategory.AccountDetails_Holdings | GACategory.AccountDetails_Transactions, productType:AccountProductType):GACategory {
//   const index:number = category === GACategory.AccountDetails_Holdings ? 0 : 1;
//   const map:{[key:string]: GACategory[]} = {
//     [AccountProductType.EQ]: [GACategory.AccountDetails_HoldingsEQ, GACategory.AccountDetails_TransactionsEQ],
//     [AccountProductType.FI]: [GACategory.AccountDetails_HoldingsFI, GACategory.AccountDetails_TransactionsFI],
//     [AccountProductType.BETA]: [GACategory.AccountDetails_HoldingsBETA, GACategory.AccountDetails_TransactionsBETA],
//     [AccountProductType.MAS]: [GACategory.AccountDetails_HoldingsMAS, GACategory.AccountDetails_TransactionsMAS],
//     [AccountProductType.SPF]: [GACategory.AccountDetails_HoldingsSPF, GACategory.AccountDetails_TransactionsSPF],
//     [AccountProductType.SSPF]: [GACategory.AccountDetails_HoldingsSSPF, GACategory.AccountDetails_TransactionsSSPF],
//     [AccountProductType.DCPF]: [GACategory.AccountDetails_HoldingsDCPF, GACategory.AccountDetails_TransactionsDCPF],
//     [AccountProductType.SPF_SSPF]: [GACategory.AccountDetails_HoldingsSPFSSPF, GACategory.AccountDetails_TransactionsSPFSSPF],
//     [AccountProductType.GEOP]: [GACategory.AccountDetails_HoldingsGEOP, GACategory.AccountDetails_TransactionsGEOP],
//     [AccountProductType.IG]: [GACategory.AccountDetails_HoldingsIG, GACategory.AccountDetails_TransactionsIG],
//     [AccountProductType.IIF]: [GACategory.AccountDetails_HoldingsIIF, GACategory.AccountDetails_TransactionsIIF],
//     [AccountProductType.PEG_SMA]: [GACategory.AccountDetails_HoldingsPEG, GACategory.AccountDetails_TransactionsPEG],
//   };
//
//   return map[productType][index];
// }
